import {
  Box,
  Collapse,
  Divider,
  Group,
  rem,
  Text,
  UnstyledButton,
} from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Link as LinkType } from '../../../types/types';
import classes from '../NavBarLinksGroup/NavbarLinksGroup.module.sass';

interface LinksGroupProps {
  initiallyOpened?: boolean;
}

export default function NavbarLinksGroup({
  icon: Icon,
  label,
  link,
  divider,
  initiallyOpened,
  links,
}: LinksGroupProps & LinkType) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const hasLinks = Array.isArray(links);
  const [opened, setOpened] = useState(initiallyOpened || false);
  const items = useMemo(
    () =>
      hasLinks
        ? links
            ?.filter((link) => link?.isDisplayed)
            .map((link) => (
              <Text
                component="div"
                fz={'sm'}
                className={classes.link}
                onClick={!!link.link ? () => navigate(link.link!) : undefined}
                key={link.link}
                data-active={pathname === link.link || undefined}
              >
                {link.label}
              </Text>
            ))
        : [],
    [links, pathname]
  );

  return (
    <>
      <UnstyledButton
        onClick={() => setOpened((o) => !o)}
        className={classes.control}
        data-active={pathname === link || undefined}
      >
        <Group
          justify="space-between"
          gap="xs"
          onClick={() => {
            if (link) {
              navigate(link);
            }
          }}
          className={classes.icon}
        >
          <Box display="flex">
            {!!Icon && <Icon style={{ width: rem(24), height: rem(24) }} />}
            <Text fz="md" ml="md" fw="bold" component="div">
              {label}
            </Text>
          </Box>
          {hasLinks && (
            <IconChevronRight
              className={classes.chevron}
              stroke={1.5}
              style={{
                width: rem(16),
                height: rem(16),
                transform: opened ? 'rotate(90deg)' : 'none',
              }}
            />
          )}
        </Group>
      </UnstyledButton>
      {hasLinks && <Collapse in={opened}>{items}</Collapse>}
      {divider && <Divider m={'xs'} />}
    </>
  );
}
